// 格式化函数
export const formatNum = (val, divisor = 1, fixed) => {
  // 数值，除数，小数位数
  if (val === null || val === undefined || val === "") return "--";
  return (Number(val) / divisor).toFixed(fixed);
};
